
/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

require('./bootstrap');

window.Vue = require('vue');

const CC = require("cookieconsent")

window.addEventListener("load", function () {
  window.cookieconsent.initialise({
    "palette": {
      "popup": {
        "background": "#3c3f3c",
        "text": "white"
      },
      "button": {
        "background": "#37bbe4",
        "text": "white"
      },
    },
    "content": {
        "href": "/cookie-policy"
    }

  });
});



import bugsnag from '@bugsnag/js'
import bugsnagVue from '@bugsnag/plugin-vue'

const bugsnagClient = bugsnag({
    notifyReleaseStages: ['production', 'staging'],
    apiKey: process.env.MIX_BUGSNAG_API_KEY,
    releaseStage: process.env.NODE_ENV,
});

window.bugsnagClient= bugsnagClient.use(bugsnagVue, Vue);
window.asset_url = process.env.MIX_ASSETS_BASE_URL;

/**
 * The following block of code may be used to automatically register your
 * Vue components. It will recursively scan this directory for the Vue
 * components and automatically register them with their "basename".
 *
 * Eg. ./components/ExampleComponent.vue -> <example-component></example-component>
 */

const files = require.context('./', true, /\.vue$/i)
files.keys().map(key => Vue.component(key.split('/').pop().split('.')[0], files(key).default))

// Vue.component('example-component', require('./components/ExampleComponent.vue').default);

/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */

import VueSweetalert2 from 'vue-sweetalert2';
Vue.use(VueSweetalert2);

import VueCarousel from 'vue-carousel';
Vue.use(VueCarousel);

import smoothscroll from 'smoothscroll-polyfill';
smoothscroll.polyfill();


const app = new Vue({
    el: '#app',
    delimiters: ['${', '}'],
    data: {
        mobilenavopen: false,
        membernavopen: false,
        videomodalopen: false,
        videoDetails: {},
        profilemodalopen: false,
        externalLinkModalOpen: false,
        newSiteHref: '',
    },
    created() {
        document.addEventListener('click', this.documentClick);
    },
    destroyed() {
        document.removeEventListener('click', this.documentClick)
    },
    methods: {
        openNav: function () {
            document.body.classList.add('modal-open');
            this.mobilenavopen = true;
        },
        closeNav: function () {
            document.body.classList.remove('modal-open');
            this.mobilenavopen = false;
        },
        toggleMemberNav: function() {
            this.membernavopen = !this.membernavopen;
        },
        showVideo(details) {
            this.videoDetails = details;
            this.videomodalopen = true;
        },
        closeVideo() {
            this.videoDetails = {};
            this.videomodalopen = false;
        },

        documentClick(e) {
            var node = e.target;
            let el = this.$refs.membersDropdownMenu
            // if (!el) return;
            if (el && (el !== node) && !el.contains(node)) {
                this.membernavopen = false
            }
            if (this.externalLinkModalOpen) {

                let el = this.$refs.externalLinkModal.$refs.modalContainer;

                let isCloseButton = !!node.closest('.close');

                if (isCloseButton || ((el !== node) && !el.contains(node))) {
                    this.hideExternalSiteMessage();
                    return false;
                }

                return true;
            }

            while (node != undefined && node.localName != 'a') {
                node = node.parentNode;
            }
            if (node != undefined) {
                if (this.isExternal(node.href)
                    &! this.isPDF(node.href)
                    &! this.isOurAsset(node.href)
                    &! this.isMailTo(node.href)
                    ) {
                    e.preventDefault();
                    this.showExternalSiteMessage(node.href);
                    return false;
                }
            }
        },

        isExternal: function (url) {
            return ((url.indexOf(':') > -1 || url.indexOf('//') > -1) && this.checkDomain(location.href) !== this.checkDomain(url));
        },
        isPDF: function(url) {
            return url.endsWith('.pdf');
        },
        isOurAsset: function(url) {
            return url.startsWith(window.asset_url);
        },
        isMailTo: function(url) {
            return url.startsWith('mailto:');
        },
        checkDomain: function (url) {
            if (url.indexOf('//') === 0) { url = location.protocol + url; }
            return url.toLowerCase().replace(/([a-z])?:\/\//, '$1').split('/')[0];
        },

        showExternalSiteMessage(href) {
            this.externalLinkModalOpen = true;
            this.newSiteHref = href;
        },
        hideExternalSiteMessage() {
            this.externalLinkModalOpen = false;
        }

    }
});
